/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CMRCoefficient } from '../models/CMRCoefficient';
import type { CMRDirection } from '../models/CMRDirection';
import type { CMRTariff } from '../models/CMRTariff';
import type { PatchedCMRCoefficient } from '../models/PatchedCMRCoefficient';
import type { PatchedCMRTariff } from '../models/PatchedCMRTariff';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CmrService {

  /**
   * CMR coefficient: read and edit.
   * @param ordering Ordering fields: risk, coefficient
   * @param risk * `theft` - Furt
 * * `frigo` - Marfă frigorifică
   * @returns CMRCoefficient 
   * @throws ApiError
   */
  public static cmrCoefficientsList(
ordering?: string,
risk?: 'frigo' | 'theft',
): CancelablePromise<Array<CMRCoefficient>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cmr/coefficients/',
      query: {
        'ordering': ordering,
        'risk': risk,
      },
    });
  }

  /**
   * CMR coefficient: read and edit.
   * @param id A unique integer value identifying this cmr coefficient.
   * @returns CMRCoefficient 
   * @throws ApiError
   */
  public static cmrCoefficientsRetrieve(
id: number,
): CancelablePromise<CMRCoefficient> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cmr/coefficients/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * CMR coefficient: read and edit.
   * @param id A unique integer value identifying this cmr coefficient.
   * @param requestBody 
   * @returns CMRCoefficient 
   * @throws ApiError
   */
  public static cmrCoefficientsPartialUpdate(
id: number,
requestBody?: PatchedCMRCoefficient,
): CancelablePromise<CMRCoefficient> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/cmr/coefficients/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * CMR transport directions: zone / country code with its localized name.
   * @param code Filter directions by code
   * @returns CMRDirection 
   * @throws ApiError
   */
  public static cmrDirectionsList(
code?: string,
): CancelablePromise<Array<CMRDirection>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cmr/directions/',
      query: {
        'code': code,
      },
    });
  }

  /**
   * CMR tariff: read and edit.
   * @param category * `general_cargo` - Încărcături generale
 * * `high_risk_cargo` - Încărcături cu risc sporit
   * @param ordering Ordering fields: category, total_amount, per_case_amount, period
   * @param perCaseAmount 
   * @param period * `1` - Lună
 * * `12` - An
   * @param totalAmount 
   * @param vehiclesQuantity 
   * @returns CMRTariff 
   * @throws ApiError
   */
  public static cmrTariffsList(
category?: 'general_cargo' | 'high_risk_cargo',
ordering?: string,
perCaseAmount?: number,
period?: 1 | 12,
totalAmount?: number,
vehiclesQuantity?: number,
): CancelablePromise<Array<CMRTariff>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cmr/tariffs/',
      query: {
        'category': category,
        'ordering': ordering,
        'per_case_amount': perCaseAmount,
        'period': period,
        'total_amount': totalAmount,
        'vehicles_quantity': vehiclesQuantity,
      },
    });
  }

  /**
   * CMR tariff: read and edit.
   * @param id A unique integer value identifying this cmr tariff.
   * @returns CMRTariff 
   * @throws ApiError
   */
  public static cmrTariffsRetrieve(
id: number,
): CancelablePromise<CMRTariff> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cmr/tariffs/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * CMR tariff: read and edit.
   * @param id A unique integer value identifying this cmr tariff.
   * @param requestBody 
   * @returns CMRTariff 
   * @throws ApiError
   */
  public static cmrTariffsPartialUpdate(
id: number,
requestBody?: PatchedCMRTariff,
): CancelablePromise<CMRTariff> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/cmr/tariffs/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
